import { Spinner } from "./SpinnerStyles";

export default Spinner;
